import React from 'react';
import { useNavigate } from 'react-router-dom';

const VARIANT_CLASS = {
  ghost: 'tp-btn--ghost',
  danger: 'tp-btn--danger',
  solid: '',
  primary: '',
};

/**
 * Renders a consistent row of CTA buttons for hero/header sections.
 * Each action can either have a `to` for navigation or a custom `onClick`.
 */
function PageActions({ actions = [] }) {
  const navigate = useNavigate();

  if (!actions.length) return null;

  return (
    <div className="tp-row" style={{ marginTop: 14 }}>
      {actions.map((action, index) => {
        const {
          label,
          to,
          onClick,
          variant = 'ghost',
          disabled = false,
          key,
        } = action;
        const className = VARIANT_CLASS[variant] || '';
        const handleClick = disabled
          ? undefined
          : onClick || (to ? () => navigate(to) : undefined);

        return (
          <button
            type="button"
            key={key || `${label}-${index}`}
            className={className}
            onClick={handleClick}
            disabled={disabled || !handleClick}
          >
            {label}
          </button>
        );
      })}
    </div>
  );
}

export default PageActions;
